<template>
    <div :class="['lazy-image', {'is-loaded' : isLoaded}, {'is-cover' : cover}]">
        <img :src="src" :alt="alt" :width="width" :height="height" @load="isLoaded = true">
    </div>
</template>

<script>
export default {
    name: "LazyImage",
    data(){
        return {
            isLoaded: false
        }
    },
    props: {
        src: {
            type: String,
            required: true
        },
        alt: {
            type: String,
            default: ""
        },
        width: [Number, String],
        height: [Number, String],
        showAnimation: {
            type: Boolean,
            default: true
        },
        cover: Boolean
    },
    watch: {
        src(){
            this.isLoaded = false;
        }
    }
}
</script>

<style lang="scss" scoped>
.lazy-image {

    display: inline-block;

    &.is-loaded {
        > img {
            opacity: 1;
        }
    }
    &.is-cover {
        > img {
            object-fit: cover;
        }
    }
    &:not(.is-cover) {
        > img {
            height: auto;
        }
    }

    &:not(.is-loaded){

        //  TODO.

    }

    > img {

        max-width: 100%;
        opacity: 0;
        transition: 1s opacity;

    }

}
</style>